export default __webpack_public_path__ + "static/media/wonder.67eab536.ttf";